import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import BackgroundImage from '@app/assets/images/auth/authbg.svg';
import Logo from '@components/common/Logo';
import Grid from '@mui/material/Grid';
import AuthCardWrapper from '@components/AuthCardWrapper';

interface AuthWrapperProps {
  children: ReactNode;
}

function AuthWrapper({ children }: AuthWrapperProps) {
  return (
    <div
      style={{
        minHeight: '100vh',
        position: 'relative',
      }}
    >
      <img
        src={BackgroundImage}
        alt="bg"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center',
          zIndex: -1,
        }}
      />
      <Grid
        container
        direction="column"
        justifyContent="flex-end"
        sx={{ minHeight: '100vh' }}
      >
        <Grid item xs={12}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ minHeight: 'calc(100vh - 68px)' }}
          >
            <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
              <Link
                to="/"
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  textAlign: 'center',
                }}
              >
                <Logo />
              </Link>
              <AuthCardWrapper>{children}</AuthCardWrapper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default AuthWrapper;
